import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'titlecase', standalone: false })
export class TitleCasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    return value.replace(/^\w+\b|(?!\bthe\b|\band\b|\ba\b|\ban\b|\bin\b|\bof\b|\bd\b|\bye\b|\b\bs\b)\b\w+/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}
